<template>
  <section class="permissions" v-if="roles">
    <div class="permissions-header">
      <div>
        <p class="permissions-header_title">
          Advanced permissions are part of the Enterprise plan
        </p>
        <p class="permissions-header_subtitle">
          Contact us to see how advanced permissions can keep your account
          secure and your work running smoothly.
        </p>
      </div>
      <button>Contact Us</button>
    </div>
    <div class="permissions-contents">
      <div class="permissions-contents_content">
        <p class="permissions-contents_content--title">Default account roles</p>
        <ul class="permissions-contents_content--roles">
          <li
            v-for="(role, i) in roles"
            :key="i"
            :class="{ active: active.name === role.name }"
            @click="active = role"
          >
            {{ role.name }}
          </li>
        </ul>
        <!--        <div class="permissions-contents_content&#45;&#45;footer">
          <p class="permissions-contents_content&#45;&#45;footer-title">
            Custom account roles
          </p>
          <p class="permissions-contents_content&#45;&#45;footer-description">
            Customized roles based on default roles <a href="#">Learn more</a>
          </p>
          <button @click="newRoleOpen = true">
            <img src="/static/img/white_plus.svg" alt="" />
            New Role
          </button>
        </div>-->
      </div>
      <div class="permissions-contents_content">
        <p class="permissions-contents_content--title">
          {{ active.name }} permissions
        </p>
        <p class="permissions-contents_content--subtitle">
          Discover more about each permission.
          <a href="#">Learn more</a>
        </p>
        <div class="permissions-contents_content--settings">
          <!--                    <div v-for="(permission, i) in active.permission" :key="i">
                        <div class="permissions-contents_content&#45;&#45;settings-title"
                            :class="{ 'active': permission.toggled }" @click="permission.toggled = !permission.toggled">
                            {{ permission.title }}
                            <img src="/static/img/chevron.svg" alt="icon">
                        </div>-->
          <div class="permissions-contents_content--settings-options">
            <div
              class="option"
              v-for="(setting, j) in scopes"
              :key="j"
              @click.stop="updateAuthGroup(setting)"
            >
              <Checkbox
                class="noClick"
                :checked="active.scopes.some((data) => data.id === setting.id)"
              />
              {{ setting.description }}
            </div>
          </div>
          <!--                    </div>-->
        </div>
      </div>
    </div>
    <Modal title="Create new Role" v-model="newRoleOpen">
      <div style="width: 100%">
        <div class="row">
          <div class="col-2 align-content-center">Name</div>
          <div class="col-10">
            <input type="text" v-model="newRole.name" />
          </div>
        </div>
        <div class="row margin">
          <div class="col-2 align-content-center">Alias</div>
          <div class="col-10">
            <input type="text" v-model="newRole.alias" />
          </div>
        </div>
        <div class="row margin">
          <div class="col-2 align-content-center">Description</div>
          <div class="col-10">
            <input type="text" v-model="newRole.description" />
          </div>
        </div>
        <br />
        <button class="saveButton" @click="createNewRole()">Save</button>
      </div>
    </Modal>
    <Modal title="Confirm Delete Role" v-model="deleteConfirmOpen">
      <div style="width: 100%">
        <br />
        <div class="confirmFooter">
          <button class="saveButton" @click="createNewRole()">Delete</button>
          <button class="saveButton" @click="createNewRole()"></button>
        </div>
      </div>
    </Modal>
  </section>
</template>
<script>
import { useLoginStore } from "../../../../stores/loginStore";
import { Checkbox } from "src/components";
import Modal from "../../Components/Modal.vue";
import AuthGroupAPIService from "../../../../servicehandlers/AuthGroupAPIService";
import ScopesAPIService from "../../../../servicehandlers/ScopesAPIService";

const authGroupsAPIService = new AuthGroupAPIService();
const scopesAPIService = new ScopesAPIService();
export default {
  components: {
    Checkbox,
    Modal,
  },
  data() {
    return {
      roles: null,
      active: null,
      scopes: null,
      newRoleOpen: false,
      newRole: {
        name: "",
        description: "",
        alias: "",
        active: true,
        isFlightSchoolSpecific: true,
        flightSchoolId: useLoginStore().getUser.flightSchoolId,
      },
      deleteConfirmOpen: false,
    };
  },
  mounted() {
    this.getAuthGroups();
    this.getScopes();
  },
  methods: {
    getAuthGroups() {
      return authGroupsAPIService
        .getActiveFlightSchoolSpecificAuthGroups(
          useLoginStore().getUser.flightSchoolId,
          this.$router,
        )
        .then(async (response) => {
          response.sort((a, b) => {
            if (a.name === "Owner") return -1;
            if (b.name === "Owner") return 1;
            return a.id - b.id;
          });
          try {
            for (let role of response) {
              let authGroup = await authGroupsAPIService.getAuthGroupsWithScope(
                role.id,
                this.$router,
              );
              role.scopes = authGroup.scopes;
            }
          } catch (e) {}

          this.roles = response;
          this.active = this.roles[0];
        });
    },
    getScopes() {
      return scopesAPIService.getScopes(this.$router).then((response) => {
        this.scopes = response;
      });
    },
    updateAuthGroup(scope) {
      if (this.active.scopes.some((data) => data.id === scope.id)) {
        let authScope = this.active.scopes.find((data) => data.id === scope.id);
        let index = this.active.scopes.indexOf(authScope);
        this.active.scopes.splice(index, 1);
        return authGroupsAPIService.removeScopeFromAuthGroup(
          this.active.id,
          scope.id,
          this.$router,
        );
      } else {
        this.active.scopes.push(scope);
        return authGroupsAPIService.addScopeToAuthGroup(
          this.active.id,
          scope.id,
          this.$router,
        );
      }
    },
    createNewRole() {
      return authGroupsAPIService
        .addAuthGroup(this.$router, this.newRole)
        .then(() => {
          this.getAuthGroups();
        });
    },
    openDeleteConfirm() {
      this.deleteConfirmOpen = true;
    },
  },
};
</script>
<style scoped lang="scss">
.confirmFooter {
  display: flex;
  justify-content: space-around;
}
.noClick {
  pointer-events: none;
}
.saveButton {
  float: right;
  margin-top: 15px;
}
.margin {
  margin-top: 15px;
}
.pointer {
  cursor: pointer;
}
.permissions {
  padding: 50px;
  display: grid;
  gap: 50px;
  width: 100%;

  p {
    margin-bottom: 0;
  }

  @media (min-width: 768px) {
    width: 800px;
  }

  &-header {
    border-radius: 15px;
    background: #bdd7bc;
    padding: 15px 20px;
    display: flex;
    gap: 25px;
    flex-direction: column;

    @media (min-width: 768px) {
      flex-direction: row;
    }

    &_title {
      color: #404040;

      font-family: Helvetica, Arial, sans-serif;
      font-size: 15px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      margin-bottom: 5px;
    }

    &_subtitle {
      color: #404040;

      font-family: Helvetica, Arial, sans-serif;
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-bottom: 0px;
    }

    button {
      height: 40px;
      align-items: center;
      border-radius: 10px;
      background: #4c854b;
      border: none;
      outline: none;

      color: #fff;

      font-family: Helvetica, Arial, sans-serif;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      white-space: nowrap;
    }
  }

  &-contents {
    gap: 70px;
    width: 100%;
    align-items: start;
    grid-template-columns: repeat(6, minmax(0, 1fr));

    @media (min-width: 768px) {
      display: grid;
    }

    &_content {
      display: grid;
      gap: 25px;

      @media (min-width: 768px) {
        grid-column: span 3 / span 3;
      }

      &--title {
        color: #404040;

        font-family: Helvetica, Arial, sans-serif;
        font-size: 15px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }

      &--subtitle {
        color: #404040;

        font-family: Helvetica, Arial, sans-serif;
        font-size: 13px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;

        a {
          color: #3c78ff;
          font-family: Helvetica, Arial, sans-serif;
          font-size: 13px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
        }
      }

      &--footer {
        display: grid;
        gap: 15px;

        &-title {
          color: #404040;
          margin-bottom: 10px;

          font-family: Helvetica, Arial, sans-serif;
          font-size: 15px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
        }

        &-description {
          color: #404040;

          font-family: Helvetica, Arial, sans-serif;
          font-size: 13px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;

          a {
            color: #3c78ff;
            font-family: Helvetica, Arial, sans-serif;
            font-size: 13px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
        }

        button {
          display: flex;
          align-items: center;
          gap: 10px;

          color: white;

          font-family: Helvetica, Arial, sans-serif;
          font-size: 15px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;

          border-radius: 10px;
          //background: rgba(64, 64, 64, 0.05);
          height: 40px;
          padding: 0 20px;
          width: fit-content;
          border: none;
        }
      }

      &--roles {
        display: grid;
        gap: 15px;
        padding-left: 0;

        li {
          list-style-type: none;
          padding: 10px 15px;
          color: #404040;

          font-family: Helvetica, Arial, sans-serif;
          font-size: 15px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          cursor: pointer;

          &:hover,
          &.active {
            border-radius: 5px;
            background: rgba(60, 120, 255, 0.25);
          }
        }
      }

      &--settings {
        display: grid;
        gap: 25px;

        &-title {
          color: #404040;
          cursor: pointer;
          font-family: Helvetica, Arial, sans-serif;
          font-size: 13px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          display: flex;
          gap: 15px;
          align-items: center;

          img {
            transition: transform 0.3s ease;
          }

          &.active {
            img {
              transform: rotate(180deg);
            }
          }
        }

        .option {
          color: rgba(64, 64, 64, 0.5);

          font-family: Helvetica, Arial, sans-serif;
          font-size: 13px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          display: flex;
          align-items: center;
          cursor: pointer;

          .form-check {
            transform: translateY(-11px);
          }
        }
      }
    }
  }
}
</style>
